import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@components/ui/button";
import { CalendarIcon, DotSquare, Ellipsis } from "lucide-react";
import { useState } from "react";

const CricketPopOver = ({ children }: { children: React.ReactNode }) => {
  const [startDateOpen, setStartDateOpen] = useState(false);

  return (
    <div className=" cursor-pointer">
      <Popover open={startDateOpen} onOpenChange={setStartDateOpen}>
        <PopoverTrigger asChild>
          <Button>
            <Ellipsis />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto px-4 py-1" align="start">
          {children}
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default CricketPopOver;
